import React from 'react';
import { Link } from 'react-router-dom';
// import style from './moduleBlocGaucheDroite2.scss';
// import './ModuleBlocGaucheDroite2.scss';
// import '../../dist/ModuleBlocGaucheDroite2.css';
import isExternal from 'is-url-external';
import * as tools from '../Tools';
import * as api from '../api.js';
import style from './ModuleBlocGaucheDroite2.scss';



export class ModuleBlocGaucheDroite2 extends React.Component {

	afficheBoutons = data => {
		return (
			<React.Fragment>
				{data.boutons.map(element => {
					return (
						<div className="text-center pt-5" style={{}}>
							{api.authentification.locked(this.props.data.roles) ?
								<span
									className={"text-center mt-5 ft-lato-light text-uppercase"}
									style={{
										fontSize: '1.1em',
										color: '#333',
										border: '1px solid #000',
										padding: '20px 60px 20px 60px',
										cursor: 'not-allowed'
									}}
								>
									{element.nom}
								</span>
								:
								<React.Fragment>
									{isExternal(element.lien) ? (
										<a
											href={element.lien}
											target="_blank"
											className={"text-center mt-5 ft-lato-light text-uppercase"}
											style={{
												fontSize: '1.1em',
												color: '#333',
												border: '1px solid #000',
												padding: '20px 60px 20px 60px'
											}}
										>
											{element.nom}
										</a>
									) : (
											<Link
												to={element.lien}
												className={"text-center mt-5 ft-lato-light text-uppercase"}
												style={{
													fontSize: '1.1em',
													color: '#333',
													border: '1px solid #000',
													padding: '20px 60px 20px 60px'
												}}
											>
												{element.nom}
											</Link>
										)}
								</React.Fragment>
							}
						</div>
					);
				})}
			</React.Fragment>
		);
	};

	render() {
		const data = this.props.data;
		const { t } = this.props;

		//const imgGauche = "url('"+tools.lienPhotos+"/"+data.imgSrc+"')";
		const image = `${tools.lienPhotos}/${data.imgSrc}`;
		//const imgDroite = `${tools.lienPhotos}/${data.imgSrc}`;
		return (
			<React.Fragment>
				{data.textPosition == 'gauche' && (
					<section className={"pt-3 moduleBlocGaucheDroite2"}>
						<section className="container item gauche">
							<figure
								style={{ backgroundImage: `url(${image})` }}
								className="figureGauche"
							>
								<img
									src={`${tools.lienPhotos}/fondModuleGaucheDroite2.png`}
									alt
								/>
							</figure>

							<div className={"moduleBlocGaucheDroite2Contenu "}>
								<div className={"boxCenter"}>
									{tools.titreSousTitre(data.titre, data.sousTitre)}

									{data.contenu}
									{this.afficheBoutons(data)}
								</div>
							</div>


						</section>
					</section>
				)}
				{data.textPosition == 'droite' && (
					<section className={"pt-3 moduleBlocGaucheDroite2"}>
						<section className="container item">
							<figure
								style={{ backgroundImage: `url(${image})` }}
								className="figureDroite"
							>
								<img
									src={`${tools.lienPhotos}/fondModuleGaucheDroite2.png`}
									alt
								/>
							</figure>
							<div className={"moduleBlocGaucheDroite2Contenu "}>
								<div className={"boxCenter"}>
									{tools.titreSousTitre(data.titre, data.sousTitre)}

									{data.contenu}
									{this.afficheBoutons(data)}
								</div>
							</div>
						</section>
					</section>)}
			</React.Fragment>
		);
	}
}

